import React, { useContext, useState, useEffect } from 'react'
import { Box, Text, Button, Grid } from "grommet"
import { CaretDown, CaretUp, StatusGoodSmall } from 'grommet-icons'
import SSH from '../../common/SSH'
import Splunk from '../../common/Splunk'
import Spare from '../../common/Spare'
// import Metrics from '../../common/Metrics'
import Icinga from '../../common/Icinga'
import MercuryEPMetrics from '../../common/MercuryEPMetrics'
import ShowServiceHistory from '../../history/ShowServiceHistory'
import Spinner from '../../common/Spinner'
import TTJsonTree from '../../common/TTJsonTree'
import TTCopyClipboard from '../../common/TTCopyClipboard'
import TTHAProxyLink from '../../common/TTHaProxyLink'

import UserContext from '../../../context/UserContext'
import EnvContext from '../../../context/EnvContext'

//import HealthStatusServiceHostMetrics from './HealthStatusServiceHostMetrics'
import HealthStatusServiceHostActions from './HealthStatusServiceHostActions'
import HealthStatusServiceDiagnostics from './HealthStatusServiceDiagnostics'
import HealthStatusServiceDataView from './HealthStatusServiceDataView'

import HealthStatusServiceAlarms from './HealthStatusServiceAlarms'

import VersionHistory from '../../version/VersionHistory'

import { gql, useQuery } from '@apollo/client';

import * as beautify from "json-beautify"

import { CombinedStats } from './HealthStatusServiceComponents'
import envConfig from '../../../utils/envConfig'
import VerifyZKData from '../../common/VerifyZKData'
import { HEALTHSTATUS_POLL_INTERVAL } from '../../../utils/pollIntervals'
import { deepClone } from '../../../utils/clone'
import TimeAgo from 'react-timeago'


const INSTANCE_QUERY = gql`
query ($instance: String!) {
    service_node(where: {instance: {_eq: $instance}}) {
      source
      status
      statusMessage
      instance
      zookeeper
      modifiedTime
      sessionType
      sessionData
      instance
      node {
        name
        ip
        environment {
          name
        }
        haNodesByHanodeid_aggregate {
          aggregate {
            count
          }
        }
        datacenter {
          name
        }
      }
      service {
        id
        serviceGroup {
          group
          groupLong
        }
      }
      mds_consumers: zookeeper(path: "custom_data.consumers")
    }
}  
`

const INSTANCE_DRAIN_QUERY = gql`
query ($instance: String!) {
    ServiceNodeView(where: {instance: {_eq: $instance}}) {
        oc_drained
        instance
    }
}
`

const MDS_CONSUMERS = {
    "pse": "mds_price_server",
    "evlog": "mds_event_logger",
    "clup": "mds_cloud_uploader",
    "ppiq": "mds_ppiq"
}


function parseColor(status) {
    if (status.toLowerCase() === "up") {
        return "ttok"
    } else if (status.toLowerCase() === "init") {
        return "ttpartial"
    } else if (status.toLowerCase() === "down") {
        return "ttdown"
    } else if (status.indexOf('UMP registration') > -1) {
        return "ttdown"
    } else if (status.indexOf('Down') > -1) {
        return "ttdown"
    } else if (status.indexOf('Error') > -1) {
        return "ttdown"
    }
    return "black"
}

export const HealthServiceDataViewStatus = ({ tab_data }) => {

    const [tabDataCount, settabDataCount] = useState({})

    useEffect(() => {
        const statusCounts = tab_data.reduce((acc, status) => {
            if (status && String(status).indexOf('LinkDown') > -1) {
                status = "down"
            }
            else if (status && String(status).length > 80) {
                status = "down"
            }
            acc[status] = acc[status] ? acc[status] + 1 : 1;
            return acc;
        }, Object.create(null));
        settabDataCount(statusCounts)
    }, [tab_data])

    return (
        <Box direction="row" gap="small" margin={{ left: "20px", top: "10px" }}>
            <Text size="xsmall" weight="bold" color="brand">Status: </Text>
            <Box direction="row" wrap={true} gap="small" overflow={{ horizontal: 'hidden', vertical: 'auto' }}>
                {tabDataCount && Object.keys(tabDataCount).length > 0 && Object.keys(tabDataCount).sort().map((status) => {
                    return (
                        <Text size="xsmall" key={status}><StatusGoodSmall size="12px" color={parseColor(status)} /> {status} : {tabDataCount[status]}</Text>
                    )
                })}
            </Box>
        </Box>
    )
}

const HealthStatusQuickActions = ({ nodeName, envName, serviceGroup, serviceGroupName,
    serviceInstanceSelected, mdsConsumer, ip, serviceName,
    datacenter, zkdata, ocServiceName = "" }) => {
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    return (
        <>
            <>
                {serviceGroupName && serviceGroupName === 'Edgeproxy' &&
                    <Box wrap={true} direction="row" gap="small" flex>
                        <MercuryEPMetrics name={nodeName} />
                        <ShowServiceHistory
                            host={nodeName}
                            env={envName}
                            service={serviceGroup}
                            instance={serviceInstanceSelected}
                            mdsConsumer={mdsConsumer}
                        />
                        <VersionHistory
                            host={nodeName}
                        />
                    </Box>
                }
            </>
            <>
                {ip && serviceGroupName !== 'Edgeproxy' &&
                    <Box wrap={true} direction="row" gap="small" flex height="55px">
                        {!envName.includes("ext-prod-live") && <SSH ip={ip} />}
                        {/* <Metrics host={nodeName} env={envName} ip={ip} service="general" /> */}
                        <ShowServiceHistory
                            host={nodeName}
                            env={envName}
                            service={serviceGroup}
                            instance={serviceInstanceSelected}
                            mdsConsumer={mdsConsumer}
                            ocServiceName={ocServiceName}
                        />
                        {serviceGroupName === 'TTHAProxy' && zkdata && !liteMode &&
                            <TTHAProxyLink url={zkdata.custom_data.statistics_report} />
                        }
                        {!liteMode &&
                            <Icinga env={envName} nodename={nodeName} />
                        }
                        {!liteMode &&
                            <Splunk env={envName} hostname={nodeName} />
                        }

                        <VersionHistory
                            host={nodeName}
                            serviceName={serviceName}
                        />

                        <Spare env={envName} service_name={serviceName} datacenter={datacenter} />
                        {/* DEB-170203 remove references to applicationVersions */}
                        {/* <Rollback env={envName} serviceName={serviceName} nodeName={nodeName} /> */}
                    </Box>
                }
            </>
        </>
    )
}


const HealthStatusService = ({ serviceInstanceSelected }) => {

    const token = useContext(UserContext)
    const envSelected = useContext(EnvContext)

    const [expandText, setExpandText] = useState(false)

    const result = useQuery(
        INSTANCE_QUERY,
        { variables: { instance: serviceInstanceSelected }, pollInterval: HEALTHSTATUS_POLL_INTERVAL }
    )

    const [serviceGroupName, setserviceGroupName] = useState("")
    const [healthStatusServiceGroupName, sethealthStatusServiceGroupName] = useState("")
    const [serviceGroup, setserviceGroup] = useState("")
    const [behindHA, setbehindHA] = useState(false)

    const shouldSkipDrainCheck = serviceGroupName === "oc" ? false : true

    const result_drain = useQuery(
        INSTANCE_DRAIN_QUERY,
        { variables: { instance: serviceInstanceSelected }, pollInterval: 1000 * 10, skip: shouldSkipDrainCheck }
    )

    useEffect(() => {
        if (!result.loading && result.data && result.data.service_node && result.data.service_node.length > 0
        ) {
            setserviceGroupName(result.data.service_node[0].service.serviceGroup.groupLong)

            // In case of mds server we might get both price server and MDS in the query result
            sethealthStatusServiceGroupName(result.data.service_node[0].service.serviceGroup.groupLong)
            result.data.service_node.forEach(i => {
                if (i.service.serviceGroup.groupLong === "MDS Adapter") {
                    sethealthStatusServiceGroupName("MDS Adapter")
                }
            })
            setserviceGroup(result.data.service_node[0].service.serviceGroup.group)

            // Check if Behind HA Proxy
            if (result.data.service_node[0].node.haNodesByHanodeid_aggregate.aggregate.count > 0) {
                setbehindHA(true)
            } else {
                setbehindHA(false)
            }
        }
    }, [result.data, result.loading])

    useEffect(() => {
        // Check for Drain
        if (result.data && result_drain.data && result_drain.data.ServiceNodeView && result_drain.data.ServiceNodeView.length > 0 &&
            result.data.service_node && result.data.service_node.length > 0 &&
            result_drain.data.ServiceNodeView[0].oc_drained) {
            result.data.service_node[0].status = 'partial'
        }
    }, [result_drain.data, result_drain.loading, result.data])

    // Checking for OC Schedule Status
    const [ocSchedule, setocSchedule] = useState({})
    useEffect(() => {
        if (!result.loading && result.data && result.data.service_node && result.data.service_node.length > 0 &&
            (serviceGroupName === "OC" || serviceGroupName === "FIX Order Gateway") && result.data.service_node[0].zookeeper &&
            result.data.service_node[0].zookeeper.custom_data &&
            result.data.service_node[0].zookeeper.custom_data.oc_information &&
            result.data.service_node[0].zookeeper.custom_data.oc_information.schedule
        ) {
            setocSchedule(result.data.service_node[0].zookeeper.custom_data.oc_information.schedule)
        }
    }, [result.loading, result.data, serviceGroupName])

    const [mdsConsumer, setmdsConsumer] = useState(false)

    useEffect(() => {
        if (!result.loading && result.data && result.data.service_node && result.data.service_node.length > 0 &&
            result.data.service_node[0].mds_consumers) {
            setmdsConsumer(true)
        }
    }, [result.loading, result.data])

    // Handling Zookeeper Data and showing zk_status as status
    const [zookeeperData, setzookeeperData] = useState({})
    const [mtime, setMtime] = useState('')

    useEffect(() => {
        if (!result.loading && result.data && result.data.service_node && result.data.service_node.length > 0 &&
            result.data.service_node[0].zookeeper) {
            let zookeeperDatatemp = deepClone(result.data.service_node[0].zookeeper);

            if (zookeeperDatatemp.zk_status) {
                zookeeperDatatemp.status = zookeeperDatatemp.zk_status
                delete zookeeperDatatemp["zk_status"]
            }
            setzookeeperData(zookeeperDatatemp)
        }
    }, [result.loading, result.data])

    useEffect(() => {
        if (!result.loading && result.data && result.data.service_node && result.data.service_node.length > 0 &&
            result.data.service_node[0].modifiedTime) {
            setMtime(result.data.service_node[0].modifiedTime)
        }
    }, [result.loading, result.data])

    if (result && (result.loading || result_drain.loading)) {
        return (
            <Spinner />
        )
    }

    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    const handleExpandClickTrue = () => {
        setExpandText(true)
    }
    const handleExpandClickFalse = () => {
        setExpandText(false)
    }

    return (
        <>
            {(result && (!result.loading && !result_drain.loading)) &&
                <Box
                    fill
                    flex={false}
                    margin='none'
                >
                    {result && result.data && result.data.service_node && result.data.service_node.length > 0 &&
                        <Box flex={false}>
                            <Box flex={false} direction="row" pad="none" gap="xxsmall" align="start" justify="center" alignContent="center" alignSelf="start">
                                <Box
                                    direction="row"
                                    alignSelf="center" alignContent="center"
                                    //width={serviceGroupName !== 'Edgeproxy' ? "220px" : "110px"}
                                    flex={false} gap="xsmall" pad="xsmall"
                                >
                                    <Box background={result.data.service_node[0].status === 'partial' ? 'ttpartial' : null} align="center">
                                        <Text color={result.data.service_node[0].status === 'up' ? 'ttok' : (result.data.service_node[0].status === 'down' ? 'ttdown' : (result.data.service_node[0].status === 'partial' ? 'dark-3' : 'dark-1'))}
                                            size="small" weight="bold" margin="none">{result.data.service_node[0].node.name}</Text>
                                    </Box>
                                    <TTCopyClipboard copyText={result.data.service_node[0].node.name} />
                                    {serviceGroupName !== 'Edgeproxy' &&
                                        <Box direction="row" align="center">
                                            <Text color="dark-3" size="small" margin="none">{result.data.service_node[0].node.ip}</Text>
                                            <TTCopyClipboard copyText={result.data.service_node[0].node.ip} />
                                        </Box>
                                    }
                                </Box>

                                {result.data.service_node[0].source && result.data.service_node[0].source === "zookeeper" &&
                                    <HealthStatusQuickActions
                                        nodeName={result.data.service_node[0].node.name}
                                        envName={result.data.service_node[0].node.environment.name}
                                        serviceGroup={serviceGroup}
                                        serviceGroupName={serviceGroupName}
                                        serviceInstanceSelected={serviceInstanceSelected}
                                        mdsConsumer={mdsConsumer}
                                        ip={result.data.service_node[0].node.ip}
                                        serviceName={((result.data.service_node[0].zookeeper.recipe).split("::")[0])}
                                        datacenter={result.data.service_node[0].node.datacenter.name}
                                        zkdata={result.data.service_node[0].zookeeper}
                                        ocServiceName={serviceGroup === "oc" ? result.data.service_node[0].zookeeper.service_name : ""}
                                    />
                                }

                            </Box>


                            {result.data.service_node[0].statusMessage &&
                                <Box flex={false} direction="row" pad="none" gap="xxsmall" align="start" justify="center" alignContent="center" alignSelf="start">

                                    {result.data.service_node[0].statusMessage.length <= 200 &&
                                        <Text size="small" color="#B4130B" margin="10px">{result.data.service_node[0].statusMessage}</Text>
                                    }
                                    {expandText && result.data.service_node[0].statusMessage.length > 200 &&
                                        <>
                                            <Text size="small" color="#B4130B" margin="10px" onClick={handleExpandClickFalse} >{result.data.service_node[0].statusMessage}</Text>
                                            <Button icon={<CaretUp color="ttdown" size="15px" />} hoverIndicator={{ color: "brand", opacity: "weak" }} onClick={handleExpandClickFalse} />
                                        </>
                                    }

                                    {!expandText && result.data.service_node[0].statusMessage.length > 200 &&
                                        <>
                                            <Text size="small" color="#B4130B" margin="10px" onClick={handleExpandClickTrue} >{result.data.service_node[0].statusMessage.substring(0, 200)} ...</Text>
                                            <Button icon={<CaretDown color="ttdown" size="15px" />} hoverIndicator={{ color: "brand", opacity: "weak" }} onClick={handleExpandClickTrue} />
                                        </>
                                    }

                                </Box>
                            }

                            <Grid
                                rows={['100%', '100%']}
                                columns={(!liteMode) ? ['200px', '72%'] : ['0%', '100%']}
                                gap="0px"
                                flex
                                areas={[
                                    { name: 'actions', start: [0, 0], end: [0, 0] },
                                    { name: 'serviceinfo', start: [1, 0], end: [1, 0] },
                                ]}
                            >

                                {result.data && result.data.service_node &&
                                    !liteMode && result.data.service_node[0].source && result.data.service_node[0].source === "zookeeper" &&

                                    <Box gridArea="actions" flex={false} direction="row" gap="none" align="start">
                                        <HealthStatusServiceHostActions
                                            instanceId={result.data.service_node[0].zookeeper.id}
                                            host={result.data.service_node[0].node.name}
                                            env={result.data.service_node[0].node.environment.name}
                                            behindHA={behindHA}
                                            serviceGroupName={healthStatusServiceGroupName}
                                            zkData={result.data.service_node[0].zookeeper}
                                        />
                                    </Box>
                                }

                                <Box gridArea="serviceinfo" margin={{ top: "5px" }} pad="small">

                                    <CombinedStats
                                        env={result.data.service_node[0].node.environment.name}
                                        service_name={((result.data.service_node[0].zookeeper.recipe).split("::")[0])}
                                        zk_start_time={result.data.service_node[0].zookeeper.start_time}
                                        ip={result.data.service_node[0].node.ip}
                                        trade_interface_ip={result.data.service_node[0].zookeeper.trade_interface_ip}
                                        node={result.data.service_node[0].node.name}
                                        marketId={(serviceGroup === 'mds' || serviceGroup === 'price_server') ? result.data.service_node[0].zookeeper.custom_data.market_id : ''}
                                        serviceGroup={serviceGroup}
                                        ocCluster={
                                            (serviceGroup === 'oc' || serviceGroup === 'fixgworders') ?
                                                (result.data.service_node[0].zookeeper.service_name !== 'canary' ?
                                                    (result.data.service_node[0].zookeeper.custom_data && result.data.service_node[0].zookeeper.custom_data.cluster &&
                                                        result.data.service_node[0].zookeeper.custom_data.cluster.name ? result.data.service_node[0].zookeeper.custom_data.cluster.name : ''
                                                    ) : 'canary') : ''
                                        }
                                        instanceId={result.data.service_node[0].zookeeper.id}
                                        bouncerCustomData={
                                            (serviceGroup === 'bouncer' ? result.data.service_node[0].zookeeper.custom_data : {})
                                        }
                                    />

                                    {mdsConsumer &&
                                        <Box flex={false} direction="row" margin={{ top: "xsmall", bottom: "xsmall" }} pad="xxsmall" background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start">{'MDS Consumers: '}
                                                {result.data.service_node[0].mds_consumers && result.data.service_node[0].mds_consumers.map(consumer => (
                                                    <Text key={consumer.consumer_name} color="ttok" size="xsmall" margin="none" textAlign="start" weight="bold">{
                                                        MDS_CONSUMERS[consumer.consumer_name] ? MDS_CONSUMERS[consumer.consumer_name] + ' ' : consumer.consumer_name + ' '
                                                    }</Text>
                                                ))}

                                            </Text>
                                        </Box>
                                    }

                                    <HealthStatusServiceDiagnostics
                                        token={token}
                                        envSelected={envSelected}
                                        ocSchedule={ocSchedule}
                                        result={result}
                                        serviceGroupName={serviceGroupName}
                                    />

                                </Box>

                            </Grid>

                            <Box border="bottom" margin={{ top: "xsmall" }}></Box>

                            <Box direction="row" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal" align="start" alignContent="start" alignSelf="start">

                                {result.data.service_node[0].source && result.data.service_node[0].source === "zookeeper" &&
                                    <>
                                        <Text name="zookeeperData" color="dark-3" size="small" margin="none" weight="bold">Zookeeper Data</Text>
                                        <TTCopyClipboard copyText={beautify(result.data.service_node[0].zookeeper, null, 2, 80)} />
                                        <VerifyZKData zookeeperData={zookeeperData} host={result.data.service_node[0].node.name}
                                            envSelected={envSelected} mTimeHasura={result.data.service_node[0].modifiedTime}
                                            zk_app_name={serviceGroup} token={token} />
                                        <Text color="dark-3" size="xsmall" margin={{ left: "xsmall" }}> Last Updated: <TimeAgo date={mtime} /> on {mtime} </Text>
                                    </>
                                }
                                {result.data.service_node[0].source && result.data.service_node[0].source === "aws" &&
                                    <Text name="awsHealthData" color="dark-3" size="small" margin="none" weight="bold">AWS Health Data</Text>
                                }

                            </Box>

                            <TTJsonTree data={zookeeperData} />

                            {result.data.service_node[0].source && result.data.service_node[0].source === "aws" && result.data.service_node[0].sessionType === "alarms" &&
                                <HealthStatusServiceAlarms data={result.data.service_node[0].sessionData} />
                            }

                            {result.data.service_node[0].source && result.data.service_node[0].source === "zookeeper" &&
                                <>
                                    <HealthStatusServiceDataView
                                        serviceGroup={serviceGroup}
                                        sessionData={result.data.service_node[0].sessionData}
                                        sessionType={result.data.service_node[0].sessionType}
                                        nodeName={result.data.service_node[0].node.name}
                                        envName={result.data.service_node[0].node.environment.name}
                                    />

                                    {/* {result.data && result.data.service_node && serviceGroupName !== 'Edgeproxy' &&
                                        <Box>
                                            <HealthStatusServiceHostMetrics
                                                metrics_key={'ZK-' + result.data.service_node[0].node.name}
                                                service={serviceGroupName}
                                                host={result.data.service_node[0].node.name}
                                                env={result.data.service_node[0].node.environment.name}
                                                ip={result.data.service_node[0].node.ip}
                                                trade_interface_ip={result.data.service_node[0].zookeeper.trade_interface_ip}
                                                variables={{
                                                    marketNames: [(result.data.service_node[0].zookeeper && result.data.service_node[0].zookeeper.custom_data && result.data.service_node[0].zookeeper.custom_data.market_name) || (result.data.service_node[0].zookeeper.service_name)]
                                                }}
                                                source={result.data.service_node[0].source}
                                            />
                                        </Box>
                                    } */}
                                </>
                            }
                        </Box>
                    }
                </Box>
            }
        </>
    )

}

export default HealthStatusService
